// extracted by mini-css-extract-plugin
module.exports = {"Spinner":"Spinner_Spinner__2St8f","load1":"Spinner_load1__3CUAJ"};